import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerPackagistProps = {
  component: object;
  range: object;
  safeVersion?: string;
  unsafeVersion?: object;
  transitive?: boolean;
  isBoth?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerPackagist: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerPackagistProps
> = props => {
  let component = props.component,
    range = props.range || {},
    safeVersion = props.safeVersion,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    transitive = props.transitive == undefined ? false : props.transitive,
    packageFile = 'composer.json',
    diffBlock = null;
  if (!transitive) {
    // Direct
    diffBlock = (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text={packageFile} />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u0022require\u0022: {'} />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={
            '\u2003\u0022' + component.coordinate1 + '\u0022: \u0022' + unsafeVersion + '\u0022'
          }
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'\u2003\u0022' + component.coordinate1 + '\u0022: \u0022' + safeVersion + '\u0022'}
        />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="normal" text="}" />
      </div>
    );
  } else {
    diffBlock = (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text={packageFile} />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u0022require\u0022: {'} />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={
            '\u2003\u0022' +
            component.coordinate1 +
            '\u0022: \u0022' +
            safeVersion +
            ' as ' +
            unsafeVersion +
            '\u0022'
          }
        />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="normal" text="}" />
      </div>
    );
  }
  return (
    <div>
      {diffBlock}
      <div className="grid pt">
        <span className="grid__item pv- p0">Execute the following to update</span>
      </div>
      <div className="pt-- -ml mt-">
        <span className="font-family--code bg-color--white-medium p-">{`php composer.phar update ${
          component.coordinate1
        }`}</span>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerPackagist;
